// features and associated entities
export const Features = [
  { name: "Dashboard", label: "Dashboard" },
  { name: "Billing and Usage", label: "Billing and Usage" },
  { name: "Service", label: "Services" },
  { name: "Reseller", label: "Resellers" },
  { name: "User", label: "Users", specialPermissions: ["Read", "Create", "Update", "Delete"] }, //Example of specialPermissions
  { name: "Roles and Permissions", label: "Roles and Permissions" },
  { name: "Industry", label: "Industries" },
  { name: "Designation", label: "Designations" },
  { name: "Skill", label: "Skills" },
  { name: "Qualification", label: "Qualifications" },
  { name: "Job Type", label: "Job Types" },
  { name: "User Profile", label: "User Profile" },
];


